import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeviceAdditionalDataComponent } from './components/device-additional-data/device-additional-data.component';
import { DeviceButtonsComponent } from './components/device-buttons/device-buttons.component';
import { DeviceFilterComponent } from './components/device-filter/device-filter.component';
import { DeviceMaterialFilterComponent } from './components/device-material-filter/device-material-filter.component';
import { DeviceProgressbarComponent } from './components/device-progressbar/device-progressbar.component';
import { DeviceSortComponent } from './components/device-sort/device-sort.component';
import { DeviceStatusNameComponent } from './components/device-status-name/device-status-name.component';
import { EmptyDevicesListComponent } from './components/empty-devices-list/empty-devices-list.component';
import { GroupManageComponent } from './components/group-manage/group-manage.component';
import { DeviceAddModalComponent } from './modals/device-add-modal/device-add-modal.component';
import { FeatureRequiringNewFirmwareModalComponent } from './modals/feature-requiring-new-firmware-modal/feature-requiring-new-firmware-modal.component';
import { ShareDeviceModalComponent } from './modals/share-device-modal/share-device-modal.component';
import { DeviceService } from './services/device.service';
import { DeviceStatusService } from './services/device-status.service';
import { SharedModule } from '@shared/shared.module';
import { AccessModule } from '@access/access.module';

@NgModule({
  declarations: [
    DeviceAdditionalDataComponent,
    DeviceButtonsComponent,
    DeviceFilterComponent,
    DeviceMaterialFilterComponent,
    DeviceProgressbarComponent,
    DeviceSortComponent,
    DeviceStatusNameComponent,
    EmptyDevicesListComponent,
    GroupManageComponent,
        
    DeviceAddModalComponent,
    ShareDeviceModalComponent,
    FeatureRequiringNewFirmwareModalComponent
  ],
  exports: [
    DeviceAdditionalDataComponent,
    DeviceButtonsComponent,
    DeviceFilterComponent,
    DeviceMaterialFilterComponent,
    DeviceProgressbarComponent,
    DeviceSortComponent,
    DeviceStatusNameComponent,
    EmptyDevicesListComponent,
    GroupManageComponent,
    
    DeviceAddModalComponent,
    ShareDeviceModalComponent,
    FeatureRequiringNewFirmwareModalComponent
  ],
  providers: [
    DeviceService,
    DeviceStatusService
  ],
  imports: [
    CommonModule,
    SharedModule,
    AccessModule
  ]
})
export class DeviceSharedModule { }
